module.exports = __webpack_public_path__ + "e338c52e9d210b472a0d8f297ddb2b74.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GF.svg
// module id = 2gk2
// module chunks = 0